export enum PhotographerQueries {
	GET_PHOTOGRAPHERS = `
    query Photographers(
        $where: PhotographerDtoFilterInput,
        $first: Int,
        $after: String ) {
            photographers(
                where: $where,
                first: $first,
                after: $after
            ) {
                nodes {
                    fullName
                    personId
                    firstName
                    lastName
                    companyId
                    email
                    phoneNumber
                    createdAt
                    contractStartDate
                    contractEndDate
                    statusId
                    statusName
                    
                    totalRevenue
                    brands {
                        brandId
                        brandName
                    }
                }

                totalCount
            }
        }
    `,
	GET_PHOTOGRAPHER_STATUSES = `
    query PhotographerStatus {
        photographerStatus {
            totalCount
            nodes {
                id
                name
            }
        }
    }

     `
}
